import { Input } from 'browser/components/atomic-elements/atoms/input/input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
export const InputField = LabelFieldFactory({ InputComponent: Input })
